<template>
    <v-container class="mx-5 mt-0">
        <v-layout v-if="show_drop_pad" column class="drop font-weight-light display-3" @dragenter="onDragover"
                  @dragover="onDragover" @drop="onDrop" style="min-height: 500px;">
            <!--<v-spacer></v-spacer>-->
            <div style="margin-top: auto; margin-bottom: auto;">Drop a file here</div>
            <!--<v-spacer></v-spacer>-->
        </v-layout>
        <div v-else style="min-height: 500px;">
            <v-card xs-2 class="mx-3 mt-3 pb-3" style="height: 56px; display:block;">
                <v-card-text v-if="file.loading">
                    <v-icon medium class="mx-3" style="margin-bottom: -6px;">cloud_upload</v-icon>
                    {{file.name}}
                    <v-progress-circular class="mx-3" color="primary" indeterminate></v-progress-circular>
                </v-card-text>
                <v-card-text v-else>
                    <v-icon v-if="file.id" medium class="mx-3" style="margin-bottom: -6px;" color="primary">cloud_done</v-icon>
                    <v-icon v-else medium class="mx-3" style="margin-bottom: -6px;" color="error">cancel</v-icon>
                    <span>{{file.name}}</span>
                </v-card-text>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "UploadFile",
        data() {
            return {
                show_drop_pad: true,
                loading: false,
                file: undefined,
            }
        },
        methods: {
            loadFile(f) {
                this.loading = true;
                this.show_drop_pad=false;
                var i = 0;
                    i++;
                    var reader = new FileReader();
                    var item={name:f.name, loading:true};
                    this.file=item;
                    reader.onload = async (e) => {
                        var data = e.target.result;
                        item.data = data;
                        this.loading = false;
                        this.$emit("upload", item);
                    };
                    reader.readAsArrayBuffer(f);
            },
            onDrop(e) {
                e.stopPropagation();
                e.preventDefault();
                this.loadFile(e.dataTransfer.files[0]);
            },
            onDragover(e) {
                e.stopPropagation();
                e.preventDefault();
                e.dataTransfer.dropEffect = 'copy';
            },
            // async uploadFile(file){
            //     var data = {};
            //     try {
            //         const response = await this.$axios.post('/api/register', file.data );
            //         console.log(response)
            //         if (response.status == 200)
            //             return data = response.data;
            //         else {
            //             //this.$events.$emit("snack", {msg: response.data, autoclose: false});
            //             return null;
            //         }
            //     } catch (e) {
            //         // handle error
            //         console.error(e);
            //         //this.$events.$emit("snack", {msg: e.message, autoclose: false});
            //         return null;
            //     }
            // }
        },
    }
</script>

<style scoped>
    .drop {
        margin: 50px;
        border: 2px dashed #bbb;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        padding: 25px;
        text-align: center;
        font: 20pt bold;
        color: #bbb;
    }
</style>